import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-playIcon",
  "use": "icon-playIcon-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-playIcon\">\n<circle opacity=\"0.5\" cx=\"25\" cy=\"25\" r=\"25\" fill=\"black\" />\n<path d=\"M38.5 24.134C39.1667 24.5189 39.1667 25.4811 38.5 25.866L19 37.1244C18.3333 37.5093 17.5 37.0281 17.5 36.2583L17.5 13.7417C17.5 12.9719 18.3333 12.4907 19 12.8756L38.5 24.134Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol